import { useCallback, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import {
  addSentryContext,
  flattenReturnPortalsFromStores,
  getSelectedReturnPortal,
  getSelectedStore,
} from '@/common/helpers/helpers'
import commonServices from '@/common/services/services'

import { transformResponseGetSystemAlerts } from './transformers'

const useBootstrap = setAppContext => {
  const { fetchData: getShopInfo } = useFetch(commonServices.getShopInfo, { doInitialRequest: false })
  const { fetchData: getUserInfo } = useFetch(commonServices.getUserProfile, { doInitialRequest: false })
  const { fetchData: getSystemAlerts } = useFetch(commonServices.getSystemAlerts, {
    doInitialRequest: false,
    transformResponse: transformResponseGetSystemAlerts,
  })

  const updateContext = useCallback(
    ({ shopInfo, userInfo, selectedStore, selectedReturnPortal, returnPortals, ...extra }) => {
      setAppContext(context => ({
        ...context,
        ...shopInfo,
        userInfo,
        selectedStore,
        selectedReturnPortal,
        returnPortals,
        isImpersonating: localStorage.isImpersonating === 'true',
        ...extra,
      }))
    },
    [setAppContext]
  )

  useEffect(() => {
    if (localStorage.jwt) {
      getShopInfo(null, shopInfo => {
        getUserInfo(null, userInfo => {
          const selectedStore = getSelectedStore(shopInfo.stores, userInfo?.default_store_id)
          const returnPortals = flattenReturnPortalsFromStores(shopInfo.stores)
          const selectedReturnPortal = getSelectedReturnPortal(returnPortals, selectedStore?.default_portal_id)
          const { store: _, ...returnPortalForStorage } = selectedReturnPortal || {}
          localStorage.selectedStore = JSON.stringify(selectedStore)
          localStorage.selectedReturnPortal = JSON.stringify(returnPortalForStorage)

          addSentryContext(selectedStore)

          const bootstrapInfo = { shopInfo, userInfo, selectedStore, selectedReturnPortal, returnPortals }

          getSystemAlerts(
            null,
            systemAlerts => updateContext({ ...bootstrapInfo, systemAlerts: systemAlerts?.results || [] }),
            () => updateContext(bootstrapInfo)
          )
        })
      })
    }
  }, [getShopInfo, getUserInfo, getSystemAlerts, updateContext])
}

export default useBootstrap
